// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.img-container[data-v-1a745e98] {\n\n    display: flex;\n\n    flex-direction: row;\n\n    justify-content: center;\n\n    padding-bottom: 3rem\n}\n.img-container img[data-v-1a745e98] {\n\n    width: 20%\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
